import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
export const getContentPlacesApis = async (isContributor, lat, lng, radius) => {
  console.log({ isContributor });
  console.log({ lat });
  console.log({ lng });
  console.log({ radius });

  try {
    let response = await _axios.get(
      `${END_POINTS.GET_CONTENT}?lat=${lat}&lng=${lng}&radius=${radius}&isContributor=${isContributor}`
    );
    console.log("response in get places", response);
    return response?.data?.data;
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};
